import FormDescriptionSection from "./form-description-section/form-description-section";
import OptionSelection from "./option-section/option-selection";
import { usePMIContext } from "../../provider/private-medical-insurance.provider";
import { OptionSelectionType } from "../../types/private-medical-insurance.type";

function PMIFormSection({ onOptionSelect }: Readonly<OptionSelectionType>) {
  const { cmsData } = usePMIContext();
  const { titleText } = cmsData.personalMedicalQuestionArea[0];

  return (
    <div className="w-full flex justify-center lg:mb-spacing-m">
      <div className="lg:w-[450px] md:w-[400px] w-full ">
        <h1
          className=" font-header-font md:text-[39px] text-[26px]
       md:leading-[45px] leading-[30px] text-text-title md:text-left text-center"
        >
          {titleText}
        </h1>
        <FormDescriptionSection />
        <OptionSelection
          onOptionSelect={(index, value) => {
            onOptionSelect(index, value);
          }}
        />
      </div>
    </div>
  );
}

export default PMIFormSection;
